import { connect } from 'react-redux';

import {
  selectLandedOnPageOne,
  selectRedirectedFromSearch,
} from 'src/components/organisms/ProductPages/modules/selectors';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectShowFeaturedProduct } from 'src/redux/products/selectors';
import type { HeaderCopyBlockProps } from '../components/HeaderCopyBlock';
import { HeaderCopyBlock } from '../components/HeaderCopyBlock';

const mapStateToProps = (state: ReduxApplicationState): HeaderCopyBlockProps => ({
  categoryDescription: state.products.category!.description,
  categoryHeading: state.products.category!.heading,
  categorySubheading: state.products.category!.subheading,
  categoryLinks: state.products.navigation[0]?.options || [],
  landedOnPageOne: selectLandedOnPageOne(state),
  openOnMount: !selectRedirectedFromSearch(state) && !selectShowFeaturedProduct(state),
});

export const HeaderCopyBlockContainer = connect(mapStateToProps)(HeaderCopyBlock);
